export const BOOLEAN = 'Boolean'
